// extracted by mini-css-extract-plugin
export default {"display_flex":"StaffMemberInformationCard_display_flex__883NZ"};